import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4 6h18V4H2v13H0v3h14v-3H4V6zm20 2h-8v12h8V8zm-2 9h-4v-7h4v7z"
}), 'DevicesSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DevicesSharp.js
// module id = 3146
// module chunks = 2